// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-widget-header {
  background: var(--chat-widget-header-bg);
  border-bottom: 1px solid var(--chat-widget-header-border);
  border-radius: 4px 4px 0px 0px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  position: relative;
  gap: 8px;
}
.chat-widget-header.transparent-style {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
}
.chat-widget-header.regular {
  align-items: flex-start;
}
.chat-widget-header.regular .info-content-data {
  display: block;
  text-align: center;
}
.chat-widget-header.regular .info-content-data .bot_icon {
  margin: 0 auto 5px auto;
}
.chat-widget-header.regular .info-content-data .img-block {
  justify-content: center;
  margin: 0 0 12px 0;
}
.chat-widget-header.regular .info-content-data .content-text h1 {
  text-align: center;
}
.chat-widget-header.regular .info-content-data .content-text h2 {
  text-align: center;
}
.chat-widget-header.regular.transparent-style {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
}
.chat-widget-header.large {
  flex-wrap: wrap;
  background: var(--chat-widget-header-bg-large);
}
.chat-widget-header.large .back-to-chat svg path {
  stroke: var(--chat-widget-header-bg-large-actions-color);
}
.chat-widget-header.large .info-content-data {
  box-shadow: 0px 5px 26px rgba(32, 33, 36, 0.25);
  border-radius: 4px;
  background: var(--chat-widget-header-bg-large-info-bg);
  margin-top: 26px;
  display: block;
  padding: 16px 10px 16px 24px;
  overflow: inherit;
}
.chat-widget-header.large .info-content-data .img-block {
  margin: -40px 0 8px 0;
}
.chat-widget-header.large .info-content-data .img-block figure {
  width: 48px;
  height: 48px;
}
.chat-widget-header.large .info-content-data .img-block figure img {
  width: 48px;
  height: 48px;
}
.chat-widget-header.large .info-content-data .bot_icon {
  margin: -40px 0 8px 0px;
  width: 48px;
  height: 48px;
}
.chat-widget-header.large .actions-info {
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 1;
}
.chat-widget-header.large .actions-info .btn-action svg path {
  fill: var(--chat-widget-header-bg-large-actions-color);
}
.chat-widget-header.large .actions-info .btn-action.btn-reconnect path {
  fill: none;
  stroke: var(--chat-widget-header-bg-large-actions-color);
}
.chat-widget-header.large .actions-info .btn-action.btn-reconnect[disabled] {
  opacity: 0.5;
}
.chat-widget-header.large.transparent-style {
  background: linear-gradient(180deg, rgba(75, 78, 222, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(10px);
}
.chat-widget-header .back-to-chat {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.chat-widget-header .back-to-chat svg path {
  stroke: var(--chat-widget-header-actions-color);
}
.chat-widget-header .info-content-data {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  gap: 8px;
}
.chat-widget-header .info-content-data .img-block {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
.chat-widget-header .info-content-data .img-block figure {
  width: 32px;
  height: 32px;
  margin-left: -18px;
}
.chat-widget-header .info-content-data .img-block figure:first-child {
  margin: 0;
}
.chat-widget-header .info-content-data .img-block figure img {
  width: 100%;
  height: 100%;
  border: 1.5px solid var(--chat-widget-header-img-border);
  border-radius: 100px;
}
.chat-widget-header .info-content-data .bot_icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  background: var(--avatar-bg);
  border-radius: 24px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.chat-widget-header .info-content-data .bot_icon svg path {
  fill: var(--avatar-icon-color);
}
.chat-widget-header .info-content-data .bot_icon span svg path {
  fill: none;
  stroke: var(--avatar-icon-color);
}
.chat-widget-header .info-content-data .content-text {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.chat-widget-header .info-content-data .content-text h1 {
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: var(--chat-widget-header-bot-name-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.chat-widget-header .info-content-data .content-text h2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--chat-widget-header-bot-name-desc);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.chat-widget-header .actions-info {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 12px;
}
.chat-widget-header .actions-info .btn-action {
  width: 20px;
  height: 20px;
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  color: var(--chat-widget-header-actions-color);
}
.chat-widget-header .actions-info .btn-action svg path {
  fill: var(--chat-widget-header-actions-color);
}
.chat-widget-header .actions-info .btn-action.btn-reconnect path {
  fill: none;
  stroke: var(--chat-widget-header-actions-color);
}
.chat-widget-header .actions-info .btn-action.btn-reconnect[disabled] {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/chatWidgetHeader/chatWidgetHeader.scss"],"names":[],"mappings":"AACA;EACI,wCAAA;EACA,yDAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;AAAJ;AACI;EACI,oCAAA;EACA,2BAAA;AACR;AACI;EACI,uBAAA;AACR;AAAQ;EACI,cAAA;EACA,kBAAA;AAEZ;AADY;EACI,uBAAA;AAGhB;AADY;EACI,uBAAA;EACA,kBAAA;AAGhB;AAAgB;EACI,kBAAA;AAEpB;AAAgB;EACI,kBAAA;AAEpB;AAEQ;EACI,oCAAA;EACA,2BAAA;AAAZ;AAGI;EACI,eAAA;EACA,8CAAA;AADR;AAIgB;EACI,wDAAA;AAFpB;AAMQ;EACI,+CAAA;EACA,kBAAA;EACA,sDAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,iBAAA;AAJZ;AAKY;EACI,qBAAA;AAHhB;AAIgB;EACI,WAAA;EACA,YAAA;AAFpB;AAGoB;EACI,WAAA;EACA,YAAA;AADxB;AAKY;EACI,uBAAA;EACA,WAAA;EACA,YAAA;AAHhB;AAMQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAJZ;AAOoB;EACI,sDAAA;AALxB;AASoB;EACI,UAAA;EACA,wDAAA;AAPxB;AAUgB;EACI,YAAA;AARpB;AAYQ;EACI,2FAAA;EACA,2BAAA;AAVZ;AAaI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAXR;AAaY;EACI,+CAAA;AAXhB;AAeI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAbR;AAcQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAZZ;AAaY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAXhB;AAYgB;EACI,SAAA;AAVpB;AAYgB;EACI,WAAA;EACA,YAAA;EACA,wDAAA;EACA,oBAAA;AAVpB;AAcQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAZZ;AAcgB;EACI,8BAAA;AAZpB;AAiBoB;EACI,UAAA;EACA,gCAAA;AAfxB;AAoBQ;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAlBZ;AAmBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAjBhB;AAmBY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAjBhB;AAqBI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AAnBR;AAoBQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,8CAAA;AAlBZ;AAoBgB;EACI,6CAAA;AAlBpB;AAsBgB;EACI,UAAA;EACA,+CAAA;AApBpB;AAuBY;EACI,YAAA;AArBhB","sourcesContent":["\n.chat-widget-header{\n    background: var(--chat-widget-header-bg);\n    border-bottom: 1px solid var(--chat-widget-header-border);\n    border-radius: 4px 4px 0px 0px;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 16px;\n    position: relative;\n    gap: 8px;\n    &.transparent-style{\n        background: rgba(255, 255, 255, 0.7);\n        backdrop-filter: blur(10px);\n    }\n    &.regular{\n        align-items: flex-start;\n        .info-content-data{\n            display: block;\n            text-align: center;\n            .bot_icon{\n                margin: 0 auto 5px auto;\n            }\n            .img-block{\n                justify-content: center;\n                margin: 0 0 12px 0;                \n            }\n            .content-text{\n                h1{\n                    text-align: center;\n                }\n                h2{\n                    text-align: center;\n                }\n            }\n        }\n        &.transparent-style{\n            background: rgba(255, 255, 255, 0.7);\n            backdrop-filter: blur(10px);\n        }\n    }\n    &.large{\n        flex-wrap: wrap;\n        background: var(--chat-widget-header-bg-large);\n        .back-to-chat{\n            svg{\n                path{\n                    stroke: var(--chat-widget-header-bg-large-actions-color);\n                }\n            }\n        }\n        .info-content-data{\n            box-shadow: 0px 5px 26px rgba(32, 33, 36, 0.25);\n            border-radius: 4px;\n            background: var(--chat-widget-header-bg-large-info-bg);\n            margin-top: 26px;\n            display: block;\n            padding: 16px 10px 16px 24px;\n            overflow: inherit;\n            .img-block{\n                margin: -40px 0 8px 0;\n                figure{\n                    width: 48px;\n                    height: 48px;\n                    img {\n                        width: 48px;\n                        height: 48px;\n                    }\n                }\n            }\n            .bot_icon{\n                margin: -40px 0 8px 0px;\n                width: 48px;\n                height: 48px;\n            }\n        }\n        .actions-info{\n            position: absolute;\n            right: 16px;\n            top: 16px;\n            z-index: 1;\n            .btn-action{\n                svg{\n                    path{\n                        fill: var(--chat-widget-header-bg-large-actions-color);\n                    }\n                }\n                &.btn-reconnect{\n                    path{\n                        fill: none;\n                        stroke: var(--chat-widget-header-bg-large-actions-color);\n                    }\n                }\n                &.btn-reconnect[disabled]{\n                    opacity: 0.5;\n                }\n            }\n        }\n        &.transparent-style{\n            background: linear-gradient(180deg, rgba(75, 78, 222, 0.7) 0%, rgba(255, 255, 255, 0) 100%);\n            backdrop-filter: blur(10px);\n        }\n    }\n    .back-to-chat{\n        width: 24px;\n        height: 24px;\n        flex-shrink: 0;\n        border: 0;\n        background: transparent;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        svg{\n            path{\n                stroke: var(--chat-widget-header-actions-color);\n            }\n        }\n    }\n    .info-content-data{\n        display: flex;\n        align-items: center;\n        width: 100%;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        gap: 8px;\n        .img-block{\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            figure{\n                width: 32px;\n                height: 32px;\n                margin-left: -18px;\n                &:first-child{\n                    margin: 0;\n                }\n                img{\n                    width: 100%;\n                    height: 100%;\n                    border: 1.5px solid var(--chat-widget-header-img-border);\n                    border-radius: 100px;\n                }\n            }\n        }\n        .bot_icon{\n            width: 32px;\n            height: 32px;\n            flex-shrink: 0;\n            background: var(--avatar-bg);\n            border-radius: 24px;\n            padding: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 16px;\n            svg {\n                path {\n                    fill: var(--avatar-icon-color);\n                }\n            }\n            span {\n                svg {\n                    path {\n                        fill: none;\n                        stroke: var(--avatar-icon-color);\n                    }\n                }\n            }\n        }\n        .content-text{\n            width: 100%;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            h1{\n                font-weight: 600;\n                font-size: 16px;\n                line-height: 19px;\n                color: var(--chat-widget-header-bot-name-color);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n            }\n            h2{\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 17px;\n                color: var(--chat-widget-header-bot-name-desc);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n            }\n        }\n    }\n    .actions-info{\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n        gap: 12px;\n        .btn-action{\n            width: 20px;\n            height: 20px;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            font-size: 20px;\n            color: var(--chat-widget-header-actions-color);\n            svg{\n                path{\n                    fill: var(--chat-widget-header-actions-color);\n                }\n            }\n            &.btn-reconnect{\n                path{\n                    fill: none;\n                    stroke: var(--chat-widget-header-actions-color);\n                }\n            }\n            &.btn-reconnect[disabled]{\n                opacity: 0.5;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
